<template>
    <ChatPersonMention :label="label" variant="linked">
        <BaseCard padding="md" radius="xl" elevated>
            <div class="flex items-center gap-3">
                <BaseAvatar><i class="bi bi-people" aria-hidden="true" /></BaseAvatar>
                <div class="flex min-w-0 grow flex-col gap-1">
                    <p class="nadia-chat-semibold leading-tight wrap-break-word text-ink">{{ teamName }}</p>
                    <p class="body-small text-ink-muted">{{ t("chatTeamMention.team") }}</p>
                </div>
            </div>
            <HorizontalDivider />
            <BaseLink
                :href="href"
                :aria-label="t('chatTeamMention.openTeam', { name: teamName })"
                class="base-btn-primary flex w-full items-center justify-center gap-2"
                :before="() => logUserInteraction(AmplitudeEventNames.TEAM_SELECTED, { source: TEAM_INTERACTION_SOURCE.CHAT_MENTION, team_id: teamId })">
                {{ t("chatTeamMention.viewTeam") }}
                <i class="bi bi-box-arrow-up-right" aria-hidden="true" />
            </BaseLink>
        </BaseCard>
    </ChatPersonMention>
</template>

<script setup lang="ts">
import ChatPersonMention from "~vue/ChatDetail/ChatPersonMention.vue";
import BaseAvatar from "~vue/components/BaseAvatar.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import HorizontalDivider from "~vue/components/HorizontalDivider.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { TEAM_INTERACTION_SOURCE } from "~vue/Teams/teamInteraction";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { useI18n } from "vue-i18n";

defineProps<{ teamId: string; label: string; teamName: string; href: string }>();
const { t } = useI18n();
</script>
